// import Tracker from '@openreplay/tracker'
import {Environment} from './config/Environment'
import { tracker } from '@openreplay/tracker'

const href = window.location.href
const url = new URL(href)

const params = {}
for (const key of url.searchParams.keys()) {
    params[key] = url.searchParams.get(key)
}

let isEnabled = false
let isLocal = false

try {
    const json = JSON.parse(Environment.REACT_APP_OPENREPLAY_IS_ENABLED.toString().toLowerCase())
    if (json === true && typeof json === 'boolean') {
        isEnabled = Environment.REACT_APP_OPENREPLAY_PROJECT_KEY
    }
} catch (e) {
    //
}

try {
    const json = JSON.parse(Environment.REACT_APP_OPENREPLAY_IS_LOCAL.toString().toLowerCase())
    if (json === true && typeof json === 'boolean') {
        isLocal = true
    }
} catch (e) {
    //
}

if(isEnabled) {
    const rawIngestPoint = isLocal
      ? `${window.location.origin}/ingest`
      : Environment.REACT_APP_OPENREPLAY_INGEST_POINT
    const ingestPoint = rawIngestPoint.startsWith('/')
      ? `${window.location.origin}${rawIngestPoint}`
      : rawIngestPoint

    tracker.configure({
        projectKey: Environment.REACT_APP_OPENREPLAY_PROJECT_KEY,
        ingestPoint: ingestPoint,
        __DISABLE_SECURE_MODE: true,
    });
    const params = new URLSearchParams(window.location.search)
    const invoice = params.get('invoice_id')

    tracker.start({
        userID: invoice,
        metadata: Object.fromEntries(params.entries()),
    })
    tracker.setUserID(invoice)
    params.forEach((value, key) => {
        if(value) {
            tracker.setMetadata(key, value)
        }
    })
    tracker.forceFlushBatch()
}
